import { useEffect, useState } from "react";

import { ApiConnector } from "../../api/api-connector";
import { MonitoringUsersDirectory } from "./monitoring-assignments";

/**
 * Loads the medical/technical classification for monitoring users once per
 * page mount. `MonitoringUsersDirectory.init` self-gates on monitoring access
 * and swallows failures, so consumers can render unconditionally.
 */
export function useMonitoringUsersDirectory(
  api: ApiConnector,
): MonitoringUsersDirectory {
  const [directory] = useState(() => new MonitoringUsersDirectory(api));

  useEffect(() => {
    void directory.init();
  }, [directory]);

  return directory;
}
